import { MetricaAtividade } from './metrica.atividade.model';
import { MetricaComplexidade } from './metrica.complexidade.model';
import { MetricaTipoAtividade } from './metrica.tipo.atividade.model';
import { MetricaTipo } from './metrica.tipo.model';

export class RequisitoMetrica {
    id: number;
    requisitoId: number;
    metricaTipoId: number;
    metricaAtividadeId: number;
    metricaComplexidadeId: number;
    descricao: string;
    hora: number;
    qtde: number;
    metricaAtividade: MetricaAtividade;
    metricaComplexidade: MetricaComplexidade
    metricaTipo: MetricaTipo
    editarMetricaStatus: boolean;
    requisitoMetricaOriginal: any;
}
